import createRandomMaze from "./createRandomMaze";
import createRandomMazeWeighted from "./createRandomMazeWeighted";
import createBinaryTreeMaze from "./binaryTree";
import createRecursiveDivisionMaze from "./recursiveDivision";
import createRecursiveDivisionWeightedMaze from "./recursiveDivisionWeighted"

const RANDOM_MAZE = "RANDOM_MAZE";
const RANDOM_MAZE_WEIGHTED = "RANDOM_MAZE_WEIGHTED";
const BINARY_TREE_MAZE = "BINARY_TREE_MAZE";
const RECURSIVE_DIVISION = "RECURSIVE_DIVISION";
const RECURSIVE_DIVISION_WEIGHTED = "RECURSIVE_DIVISION_WEIGHTED";

export {
	createRandomMaze,
	createRandomMazeWeighted,
	createBinaryTreeMaze,
	createRecursiveDivisionMaze,
	createRecursiveDivisionWeightedMaze,
	RANDOM_MAZE,
	RANDOM_MAZE_WEIGHTED,
	BINARY_TREE_MAZE,
	RECURSIVE_DIVISION,
	RECURSIVE_DIVISION_WEIGHTED
};
